import styles from './style.module.css';

// "What happens next": the numbered steps the blueprint puts under a form
// whose result happens somewhere else, such as an invitation the patient
// answers later.
export function NextSteps({ title, steps }) {
  const items = steps.map(function(step, index) {
    // The steps are fixed copy, never reordered, so their position is their
    // identity.
    return <li key={ index } className={ styles.step }>{ step }</li>;
  });

  return (
    <div className={ styles.box }>
      <span className={ styles.title }>{ title }</span>

      <ol className={ styles.steps }>{ items }</ol>
    </div>
  );
}
